export function assemblyQueuePath(): string {
  return "/manufacturing/assembly";
}

export function assemblyWorkOrderPath(buildOrderId: number): string {
  return `/manufacturing/assembly/work-orders/${String(buildOrderId)}`;
}
